module.exports = __webpack_public_path__ + "img/Pro_Unselected.b7064236.svg";